import { LogMethodName } from '../../types/logging';
import makeLogger from '../../utils/makeLogger';

export default makeLogger('database', {
  shouldLog(methodName, module, message, extra) {
    return [LogMethodName.Error, LogMethodName.Info, LogMethodName.Warn].includes(methodName);
  },
});
